// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50d17a4c","746":"6116ec38"}[chunkId] + ".chunk.js";
};